
import moment from 'moment';
import { Component, Mixins } from 'vue-property-decorator';
import { getGoods, updateGoods } from '@/api/specialGoods';
import SpecialGoodsItem from './special-goods-item.vue';
import { PageQuery } from '@/mixins/page_query';
import { GoodsType } from '@/utils/common';

@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    formatAmount(amout: number) {
      return (amout / 100).toFixed(1);
    },
  },
  components: {
    SpecialGoodsItem,
  },
})
export default class SpecialGoods extends Mixins(PageQuery) {
  detail: any = null;
  dialogVisible: boolean = false;
  private isEdit: boolean = false;
  private goods_id: string = '';
  private goods_name: string = '';
  private goods_category: number = 0;
  private categoryOptions = [
    {
      value: 0,
      label: '请选择商品类型',
    },
    {
      value: GoodsType.COIN,
      label: '云币',
    },
    {
      value: GoodsType.CARD,
      label: '周期卡',
    },
  ];
  private tableData: {
    id?: number; // 商品ID
    name: string; // 商品名称
    goods_type: number; // 商品类型
    amount?: string; // 云币价格
    subcard_duration?: number; // 周期卡时长
    valid_day_remark?: string; // 周期卡时长说明
    valid_days?: number; //激活后有效天数
    cost: number; // 商品金额
    expire_at: any; // 截止购买日期(timestamp)
    limit: number; // 购买次数
    desc?: string; // 商品说明
    open: boolean; // 状态
    created_at: string; // 创建时间(timestamp)
  }[] = [];

  private showCreateForm() {
    this.isEdit = false;
    this.detail = null;
    this.dialogVisible = true;
  }

  private getCategoryTitle(val: number) {
    const category = this.categoryOptions.find(c => c.value === val);
    if (category) {
      return category.label;
    }
  }

  private getAmount(item: any) {
    if (item.type === GoodsType.COIN) {
      return item.coin_amount + this.getCategoryTitle(item.type);
    }
    return item.sub_card_amount + '分钟' + this.getCategoryTitle(item.type);
  }

  private getDialogTitle(): string {
    const prefix: string = this.isEdit ? '查看' : '新建特殊';
    return prefix + '商品';
  }

  private showDetail(item: any) {
    this.detail = item;
    this.isEdit = true;
    this.dialogVisible = true;
  }

  searchList() {
    this.page_query.page = 1;
    this.getList();
  }

  private handleChangeStatus(item: any) {
    const _this = this;
    if (!item.open) {
      _this
        .$confirm('确认禁用吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          updateGoods({ id: item.id, open: item.open }).then(() => {
            _this.$message({
              type: 'success',
              message: '禁用成功!',
            });
          });
        })
        .catch(() => {
          item.open = !item.open;
        });
    } else {
      updateGoods({ id: item.id, open: item.open }).then(() => {
        _this.$message({
          type: 'success',
          message: '启用成功!',
        });
      });
    }
  }

  async getList() {
    try {
      this.dialogVisible = false;
      const query = {
        page: this.page_query.page,
        page_size: this.page_query.page_size,
        id: this.goods_id,
        name: this.goods_name,
        type: this.goods_category,
      };
      const res = await getGoods(query);
      if (res && res.data.list) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      // this.$log.debug(error);
      console.error(error);
    }
  }
  mounted() {
    this.getList();
  }
}
